import React from 'react'
import { HelpCircle } from 'react-feather'
import './FormLabelWithTooltip.scss'

export function FormLabelWithTooltip({
  htmlFor,
  children,
  required,
  tooltip
}) {
  return (
    <label className="form-label-with-tooltip" htmlFor={htmlFor}>
      <span className="form-label-with-tooltip__text">
        {children}
        {required ? (
          <abbr
            className="form-label-with-tooltip__req"
            title="obrigatório"
            aria-label="obrigatório"
          >
            *
          </abbr>
        ) : null}
      </span>
      {tooltip ? (
        <span
          className="form-label-with-tooltip__tip"
          tabIndex={0}
          role="tooltip"
          title={tooltip}
          aria-label={tooltip}
        >
          <HelpCircle size={14} aria-hidden />
        </span>
      ) : null}
    </label>
  )
}
